import { getDsnInstance } from '@demo-system/commons/service/dsn';
import { makeUseAxios } from 'axios-hooks';
import { ACCESS_TOKEN, API_ROOT } from './environment';

const dsnInstance = getDsnInstance({
  accessToken: ACCESS_TOKEN,
  apiUrl: API_ROOT
});

export const useDsnAxios = makeUseAxios({ axios: dsnInstance });

export default dsnInstance;
